var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAfrica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 213,
    viewBox: "0 0 213 213",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M213 106.488C213.01 127.787 206.629 148.6 194.683 166.235C182.738 183.87 165.776 197.517 145.991 205.41V205.41C124.431 214.018 100.648 215.343 78.2648 209.184C55.8818 203.026 36.1254 189.721 22.0047 171.296V171.296C12.7322 159.185 6.16208 145.229 2.73673 130.366C-0.688608 115.503 -0.889708 100.079 2.14697 85.132V85.132L2.25989 84.5836C5.80492 67.7911 13.3501 52.1019 24.2549 38.848C35.1597 25.5942 49.102 15.167 64.8981 8.45198V8.45198C75.6658 3.90744 87.1134 1.18211 98.774 0.387191C101.403 0.0968587 103.936 8.12367e-05 106.501 8.12367e-05C133.292 -0.0330113 159.109 10.0454 178.791 28.2207C198.473 46.396 210.569 71.3291 212.662 98.0357C212.887 100.81 213 103.649 213 106.488Z",
    fill: "#E9F1F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M212.66 98.0343L210.515 97.4859C208.273 96.9213 206.772 78.7272 204.369 77.6788C201.965 76.6303 201.675 67.7752 200.013 67.7752C198.352 67.7752 197.771 69.872 195.819 75.7432C193.867 81.6144 195.819 83.0822 195.819 85.7919C195.819 88.5017 195.367 93.5825 193.722 91.776C192.077 89.9695 184.866 69.2752 182.011 68.8397C179.155 68.4042 176.623 62.3879 174.526 61.4847C172.429 60.5814 171.057 61.9363 167.315 61.9363C163.572 61.9363 163.266 58.9201 161.604 59.0814C159.943 59.2426 157.862 58.1942 155.023 57.8878C152.184 57.5813 149.845 52.4198 148.038 54.8877C146.231 57.3555 150.167 61.8073 153.765 63.7751C157.362 65.7429 158.604 63.3718 161.088 64.1299C163.572 64.888 164.831 69.0978 163.492 72.856C162.153 76.6142 158.523 78.582 154.345 80.3885C150.167 82.195 147.312 83.6144 146.425 78.082C145.538 72.5496 133.939 62.6944 132.584 60.8879C131.229 59.0814 131.197 55.5006 129.358 55.9522C126.857 56.4845 125.341 58.162 125.793 58.9039C126.244 59.6459 132.245 70.2914 138.069 74.0657C142.747 77.0497 144.376 84.2919 146.312 86.8242C147.731 88.6953 151.458 87.9049 154.878 86.9533C155.308 86.8321 155.762 86.8221 156.198 86.924C156.633 87.026 157.035 87.2366 157.367 87.5362C157.699 87.8359 157.95 88.2147 158.096 88.6374C158.241 89.0601 158.277 89.5129 158.201 89.9534C155.813 101.776 140.65 109.728 139.037 116.067C137.246 123.116 141.44 131.664 140.537 135.278C139.634 138.891 130.777 139.31 130.035 142.778C129.293 146.246 135.262 148.939 130.761 151.326C128.18 152.665 128.422 148.762 127.035 153.568C124.615 161.988 113.243 166.02 109.177 167.053C105.112 168.085 101.999 166.617 103.031 163.827C104.064 161.036 100.192 150.617 95.3851 147.165C90.578 143.713 90.5457 139.1 93.772 127.664C96.9983 116.228 81.0282 117.632 84.932 108.019C88.8358 98.4053 81.625 99.1634 77.1244 95.1148C72.6237 91.0663 60.4929 110.97 46.9425 91.1308C33.3922 71.2914 53.8468 57.8394 56.9924 55.7425C60.138 53.6457 65.8485 46.2906 67.3488 46.7261C68.849 47.1616 78.431 44.7905 81.867 43.5808C85.303 42.3711 91.0135 41.7904 91.9169 43.5808C92.8202 45.3712 88.1744 44.6454 90.707 47.7906C93.2396 50.9359 116.517 53.0328 121.163 52.6295C125.809 52.2263 126.874 53.2263 128.648 48.4197C130.422 43.6131 120.695 44.0808 118.017 44.5163C115.34 44.9518 115.324 38.871 111.565 43.1937C109.952 45.1454 106.725 40.984 106.467 37.8064C106.209 34.6289 97.4661 30.7255 95.9497 33.1289C94.4334 35.5322 102.789 36.8548 102.999 37.9677C103.128 38.5 101.499 40.6614 100.596 42.3227C99.6922 43.9841 99.4018 42.3227 99.5631 40.8227C99.7245 39.3226 95.2722 38.4032 93.6429 36.4677C92.0136 34.5321 87.9163 33.4514 84.1415 34.6773C80.3668 35.9031 80.2539 36.4193 76.6566 40.1614C73.0593 43.9034 66.2841 42.9195 65.3646 42.3227C64.4451 41.7259 66.2841 37.4838 66.7196 34.9999C67.1552 32.5159 71.8333 34.0805 74.3659 34.8225C76.8985 35.5644 76.7695 33.774 76.3339 31.0804C75.8984 28.3868 76.9308 27.1125 78.431 26.8061C79.9312 26.4996 87.4001 25.5157 90.7231 22.064C93.3042 19.4026 97.4822 21.322 99.5793 21.322C101.676 21.322 108.387 20.4349 109.468 13.2572C109.742 11.4668 110.226 9.64418 107.258 11.6443C105.066 12.7703 103.354 14.6486 102.435 16.9348C101.531 19.1768 94.2075 18.3219 91.562 16.8218C88.9164 15.3218 92.3201 13.7895 99.8535 8.53124C107.387 3.273 118.017 11.1926 120.647 10.8055C123.276 10.4184 130.761 2.74072 130.761 2.74072C152.757 7.88295 172.548 19.8873 187.27 37.0179C201.993 54.1485 210.885 75.5173 212.66 98.0343V98.0343Z",
    fill: "url(#paint0_linear_757_1299)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.43 21.7738C72.672 21.7738 76.6726 19.8544 76.979 20.6286C77.2855 21.4028 75.6079 23.8545 74.7045 24.161C73.8012 24.4674 70.5104 25.1287 70.4458 24.5803C70.3813 24.0319 72.43 21.7738 72.43 21.7738Z",
    fill: "url(#paint1_linear_757_1299)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8347 17.0492C80.8347 17.0492 82.0284 15.8556 82.8027 16.2104C83.577 16.5653 85.8031 21.0493 85.8031 21.0493C85.8031 21.0493 80.4153 24.2752 79.0602 23.9688C77.7052 23.6623 81.367 19.2589 80.8347 17.0492Z",
    fill: "url(#paint2_linear_757_1299)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M197.722 89.6301C197.436 91.3224 197.436 93.0509 197.722 94.7432C198.029 95.6142 199.336 94.34 199.61 93.8561C199.885 93.3722 197.932 89.5172 197.722 89.6301Z",
    fill: "url(#paint3_linear_757_1299)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M146.796 136.955C146.636 137.05 146.498 137.178 146.392 137.331C146.286 137.484 146.215 137.658 146.183 137.842C145.941 139.584 146.473 141.987 145.731 143.245C144.989 144.503 142.392 149.907 143.553 151.31C144.715 152.713 147.893 153.633 148.796 152.133C149.699 150.633 158.652 129.842 155.539 129.842C153.458 129.842 155.216 132.342 152.313 133.826C150.216 134.906 147.812 136.293 146.796 136.955Z",
    fill: "url(#paint4_linear_757_1299)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0033 171.295C7.71272 152.714 -0.024145 129.926 5.6606e-05 106.487C-0.00114809 99.4462 0.690456 92.4229 2.06487 85.5181C2.06487 85.5181 2.14553 85.5181 2.14553 85.5181C2.14553 88.4537 2.40363 106.728 6.48488 108.519C10.9049 110.438 18.8738 113.632 19.39 118.874C19.9062 124.116 16.8735 130.923 17.7768 133.858C18.6802 136.794 20.0352 146.94 19.39 148.375C18.7447 149.811 16.2766 149.407 17.4058 152.827C18.535 156.246 22.2452 164.408 22.2452 166.569C22.3082 168.149 22.2272 169.73 22.0033 171.295V171.295Z",
    fill: "url(#paint5_linear_757_1299)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M145.989 205.409C126.399 213.197 104.943 215.021 84.3188 210.651C86.005 208.967 88.1671 207.841 90.5133 207.425C94.288 206.844 112.387 206.844 115.581 206.28C118.776 205.715 128.019 202.909 130.455 204.022C132.608 205.316 135.112 205.908 137.617 205.715C140.246 205.409 145.102 205.764 145.989 205.409Z",
    fill: "url(#paint6_linear_757_1299)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_757_1299",
    x1: 42.3518,
    y1: 85.0622,
    x2: 212.66,
    y2: 85.0622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#085078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85D8CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_757_1299",
    x1: 70.4443,
    y1: 22.6177,
    x2: 77.0159,
    y2: 22.6177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#085078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85D8CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_757_1299",
    x1: 78.7573,
    y1: 20.0669,
    x2: 85.8031,
    y2: 20.0669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#085078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85D8CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_757_1299",
    x1: 197.507,
    y1: 92.334,
    x2: 199.637,
    y2: 92.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#085078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85D8CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_757_1299",
    x1: 143.259,
    y1: 141.372,
    x2: 156.194,
    y2: 141.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#085078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85D8CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_757_1299",
    x1: 0,
    y1: 128.407,
    x2: 22.2659,
    y2: 128.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#085078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85D8CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_757_1299",
    x1: 84.3188,
    y1: 208.368,
    x2: 145.989,
    y2: 208.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#085078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85D8CE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfrica);
export default __webpack_public_path__ + "static/media/africa.6439e614d4332636e94243a58c11dbac.svg";
export { ForwardRef as ReactComponent };